const translations = {
    en: {
        title: "Pair Programming Timekeeper",
        timer: {
            oneMin: "1 min",
            tenMin: "10 min",
            fiftyMin: "50 min",
            oneHour: "1 hour",
            customPlaceholder: "custom seconds"
        },
        buttons: {
            start: "Start",
            pause: "Pause",
            continue: "Continue",
            reset: "Reset"
        },
        help: {
            link: "Help / About",
            title: "Pair Programming Timekeeper",
            paragraph1: "The app offers flexible time intervals catering to the dynamic nature of pair programming sessions.",
            paragraph2: "Users can choose from intervals of 1 minute, 10 minutes, 50 minutes, and 1 hour to structure their collaborative coding sessions.",
            paragraph3: "Pair programming sessions often benefit from periodic breaks to maintain productivity and engagement.",
            paragraph4: "The app helps teams to switch roles between the driver and navigator, fostering a balanced and effective collaboration rhythm."
        },
        language: {
            label: "Language"
        }
    },
    ja: {
        title: "ペアプログラミングタイムキーパー",
        timer: {
            oneMin: "1分",
            tenMin: "10分",
            fiftyMin: "50分",
            oneHour: "1時間",
            customPlaceholder: "秒数を入力"
        },
        buttons: {
            start: "開始",
            pause: "一時停止",
            continue: "続行",
            reset: "リセット"
        },
        help: {
            link: "ヘルプ / 概要",
            title: "ペアプログラミングタイムキーパー",
            paragraph1: "このアプリは、ペアプログラミングセッションの動的な性質に対応する柔軟な時間間隔を提供します。",
            paragraph2: "ユーザーは1分、10分、50分、1時間の間隔から選択して、共同コーディングセッションを構成できます。",
            paragraph3: "ペアプログラミングセッションは、生産性とエンゲージメントを維持するために定期的な休憩から恩恵を受けることがよくあります。",
            paragraph4: "このアプリは、チームがドライバーとナビゲーターの役割を切り替えるのを支援し、バランスの取れた効果的なコラボレーションリズムを育みます。"
        },
        language: {
            label: "言語"
        }
    },
    it: {
        title: "Cronometro per Pair Programming",
        timer: {
            oneMin: "1 min",
            tenMin: "10 min",
            fiftyMin: "50 min",
            oneHour: "1 ora",
            customPlaceholder: "secondi personalizzati"
        },
        buttons: {
            start: "Inizia",
            pause: "Pausa",
            continue: "Continua",
            reset: "Ripristina"
        },
        help: {
            link: "Aiuto / Informazioni",
            title: "Cronometro per Pair Programming",
            paragraph1: "L'app offre intervalli di tempo flessibili che si adattano alla natura dinamica delle sessioni di pair programming.",
            paragraph2: "Gli utenti possono scegliere tra intervalli di 1 minuto, 10 minuti, 50 minuti e 1 ora per strutturare le loro sessioni di codifica collaborativa.",
            paragraph3: "Le sessioni di pair programming spesso beneficiano di pause periodiche per mantenere la produttività e l'impegno.",
            paragraph4: "L'app aiuta i team a cambiare ruolo tra driver e navigator, favorendo un ritmo di collaborazione equilibrato ed efficace."
        },
        language: {
            label: "Lingua"
        }
    }
};

export default translations;
